// extracted by mini-css-extract-plugin
export default {"image":"_a60b449f"};